import moment from 'moment';

export default ((
{ monthsMap, videos }) =>
{
  const radix = 10;

  videos.forEach((video) => {
    const month = moment(parseInt(video.createdAt, radix)).month();
    const monthsArray = monthsMap.get(month);

    if (monthsArray) {
      monthsArray.push(video);
    }
  });

  return monthsMap;
});